"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingDetailsEventName = exports.TrackingDetailsEventDate = exports.TrackingDetailsEvent = exports.TrackingDetailsTitle = exports.InnerContent = exports.Content = exports.Arrow = exports.Status = exports.Detail = exports.Title = exports.ServiceBlock = exports.RowsContainer = exports.Container = exports.ShadowContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _animations = require("../../../styles/animations");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var ShadowContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  border-radius: ", "px;\n  transition: box-shadow ", "s;\n  &:hover{\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n  }\n"])), _widths.widths.base, _animations.animations.base);

exports.ShadowContainer = ShadowContainer;
ShadowContainer.displayName = 'ShadowContainer';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  font-family: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", " ;\n  padding: ", "px;\n  transition: border ", "s;\n  ", " {\n    align-items: center;\n  }\n  ", " {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n"])), _widths.font.montse, _palette.palette.white, function (_ref) {
  var open = _ref.open;
  return open ? '#0A48EC' : _palette.palette.lightGrey;
}, function (_ref2) {
  var open = _ref2.open;
  return open ? "".concat(_widths.widths.base, "px ").concat(_widths.widths.base, "px 0 0") : "".concat(_widths.widths.base, "px");
}, _widths.widths.base * 3, _animations.animations.base * 2, _widths.mediaQueries.desktop, _widths.mediaQueries.notDesktop);

exports.Container = Container;
Container.displayName = 'Container';

var RowsContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  &>div:not(:first-child) {\n    margin-left: ", "px;\n  }  \n"])), _widths.widths.base * 4);

exports.RowsContainer = RowsContainer;
RowsContainer.displayName = 'RowsContainer';

var ServiceBlock = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n"])));

exports.ServiceBlock = ServiceBlock;
ServiceBlock.displayName = 'ServiceBlock';

var Title = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 12px;\n  color: ", ";\n  font-weight: ", ";\n  line-height: ", "px;\n"])), _palette.palette.grey, _widths.font.regular, _widths.widths.base * 2);

exports.Title = Title;
Title.displayName = 'Title';

var Detail = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n  margin: ", "px 0px;\n"])), _palette.palette.bobBlack, _widths.font.semi, _widths.widths.base * 2, _widths.widths.base * 3, _widths.widths.base);

exports.Detail = Detail;
Detail.displayName = 'Detail';

var Status = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  border-radius: 80px;\n  font-size: 12px;\n  text-transform: capitalize;\n  padding: ", "px ", "px;\n  background: ", ";\n  font-weight: ", ";\n  line-height: ", "px;\n  color: ", ";\n"])), _widths.widths.base / 2, _widths.widths.base, function (_ref3) {
  var background = _ref3.background;
  return background || _palette.palette.darkWhite;
}, _widths.font.medium, _widths.widths.base * 2, function (_ref4) {
  var color = _ref4.color;
  return color || _palette.palette.bobBlack;
});

exports.Status = Status;
Status.displayName = 'Status';

var Arrow = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  bottom: ", "px;\n  left: calc(50% - 7px);\n  transform: rotateX(", ");  \n  transition: transform ", "s;\n  & path {\n    fill: #0A48EC;\n  }\n"])), _widths.widths.base, function (_ref5) {
  var open = _ref5.open;
  return open ? '0deg' : '180deg';
}, _animations.animations.base * 2);

exports.Arrow = Arrow;
Arrow.displayName = 'Arrow';

var Content = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n"])));

exports.Content = Content;
Content.displayName = 'Content';

var InnerContent = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 0;\n  padding: 0 1em;\n  background: ", ";\n  transition: all ", "s, padding-left 100s, padding-right 100s;\n", ";\n"])), _palette.palette.white, _animations.animations.base, function (_ref6) {
  var open = _ref6.open;
  return open ? "\n  transition: all ".concat(_animations.animations.base * 2, "s, padding-left 1ms, padding-right 1ms;\n  max-height: 100vh;\n  padding: ").concat(_widths.widths.base * 3, "px;\n  border: 1px solid #0A48EC;\n  border-radius: 0 0 ").concat(_widths.widths.base, "px ").concat(_widths.widths.base, "px;\n  overflow: hidden;\n  ") : '';
});

exports.InnerContent = InnerContent;
InnerContent.displayName = 'InnerContent';

var TrackingDetailsTitle = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n  color: ", ";\n  margin-top: ", "px;    \n"])), _widths.font.semi, _widths.widths.base * 2, _widths.widths.base * 3, _palette.palette.bobBlack, _widths.widths.base * 6);

exports.TrackingDetailsTitle = TrackingDetailsTitle;
TrackingDetailsTitle.displayName = 'TrackingDetailsTitle';

var TrackingDetailsEvent = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  margin-top: ", "px;\n  ", " {\n    flex-direction: column;\n    margin-top: ", "px;\n    &>div:not(:first-child) {\n      margin-top: ", "px;\n    }\n  }  \n"])), _widths.widths.base, _widths.mediaQueries.notDesktop, _widths.widths.base * 3, _widths.widths.base);

exports.TrackingDetailsEvent = TrackingDetailsEvent;
TrackingDetailsEvent.displayName = 'TrackingDetailsEvent';

var TrackingDetailsEventDate = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: ", "px;\n  color: ", ";\n"])), _widths.font.regular, _widths.widths.base * 3, _palette.palette.grey);

exports.TrackingDetailsEventDate = TrackingDetailsEventDate;
TrackingDetailsEventDate.displayName = 'TrackingDetailsEventDate';

var TrackingDetailsEventName = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: ", "px;\n  color: ", ";\n  ", " {\n    margin-left: ", "px;\n  }\n"])), _widths.font.semi, _widths.widths.base * 3, _palette.palette.bobBlack, _widths.mediaQueries.desktop, _widths.widths.base * 10);

exports.TrackingDetailsEventName = TrackingDetailsEventName;
TrackingDetailsEventName.displayName = 'TrackingDetailsEventName';